import { useEffect } from 'react';
import pixel from './service/pixel';

const PixelManager = () => {
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const pixelFromUrl = query.get('pixel');
    const ownerFromUrl = query.get('owner');
    console.log('-----------------------pixel------------------')
    console.log(query)
    console.log(pixelFromUrl)
    console.log('-----------------------pixel------------------')
    const defaultPixel = '359662794670623'; // ✅ ton pixel global

    const pixelsToInit = [defaultPixel]; // Toujours inclure le pixel global

    if (pixelFromUrl) {
      pixelsToInit.push(pixelFromUrl);

      // Stocker pixels pour les futures visites
      document.cookie = `pixelId=${pixelFromUrl}; path=/; max-age=604800`;
      if (ownerFromUrl) {
        document.cookie = `pixelOwnerId=${ownerFromUrl}; path=/; max-age=604800`;
      }
    } else {
      // Checker le cookie pixel organisateur
      const pixelMatch = document.cookie.match(/(^| )pixelId=([^;]+)/);
      if (pixelMatch) {
        pixelsToInit.push(pixelMatch[2]);
      }
    }

    // Init tous les pixels (global + éventuellement organisateur)
    pixel.initPixel(pixelsToInit);
  }, []);

  return null;
};

export default PixelManager;
